// PaymentLinks/PaymentLinksFilters.jsx
import React from 'react';
import { Search, Add, Share } from '@mui/icons-material';

const statusFilters = [
    { id: 'all', label: 'Tous' },
    { id: 'pending', label: 'En attente' },
    { id: 'paid', label: 'Payés' },
    { id: 'collected', label: 'Collectés' },
    { id: 'expired', label: 'Expirés' }
];

/**
 * Barre de filtres des liens : une seule ligne dès sm (les statuts défilent si la place manque),
 * empilée sur téléphone.
 */
export const PaymentLinksFilters = ({
                                        searchTerm,
                                        onSearchChange,
                                        filterStatus,
                                        onFilterChange,
                                        onCreateLink,
                                        onSharePermanentLink
                                    }) => {
    return (
        <div className="bg-white rounded-2xl p-4 sm:p-5 border border-slate-200 shadow-sm">
            <div className="flex flex-col gap-3 sm:flex-row sm:items-center">
                {/* Recherche */}
                <div className="relative w-full sm:w-44 lg:w-56 xl:w-64 shrink-0">
                    <Search className="absolute left-3 top-1/2 -translate-y-1/2 text-slate-400" fontSize="small" />
                    <input
                        type="text"
                        placeholder="Rechercher un lien..."
                        className="w-full pl-9 pr-3 py-2.5 border border-slate-300 rounded-xl text-sm focus:ring-2 focus:ring-amber-500 focus:border-amber-500 transition-all duration-200"
                        value={searchTerm}
                        onChange={(e) => onSearchChange(e.target.value)}
                    />
                </div>

                {/* Statuts : retour à la ligne sur mobile, une seule ligne défilante au-delà */}
                <div className="flex flex-wrap gap-2 sm:flex-nowrap sm:flex-1 sm:min-w-0 sm:overflow-x-auto">
                    {statusFilters.map(filter => (
                        <button
                            key={filter.id}
                            type="button"
                            onClick={() => onFilterChange(filter.id)}
                            className={`shrink-0 px-3 lg:px-4 py-2 rounded-xl whitespace-nowrap text-sm font-medium transition-all duration-200 ${
                                filterStatus === filter.id
                                    ? 'bg-gradient-to-r from-amber-500 to-orange-500 text-white shadow-sm'
                                    : 'text-slate-600 hover:text-amber-600 hover:bg-amber-50 border border-slate-200'
                            }`}
                        >
                            {filter.label}
                        </button>
                    ))}
                </div>

                {/* Actions */}
                <div className="grid grid-cols-2 gap-2 sm:flex sm:items-center sm:shrink-0">
                    <button
                        type="button"
                        onClick={onSharePermanentLink}
                        title="Lien permanent"
                        className="flex items-center justify-center gap-2 px-3 lg:px-4 py-2.5 bg-amber-50 text-amber-800 border border-amber-200 rounded-xl hover:bg-amber-100 transition-all duration-300 text-sm font-semibold"
                    >
                        <Share fontSize="small" />
                        <span className="sm:hidden xl:inline">Lien permanent</span>
                    </button>
                    <button
                        type="button"
                        onClick={onCreateLink}
                        title="Nouveau lien"
                        className="flex items-center justify-center gap-2 px-3 lg:px-4 py-2.5 bg-gradient-to-r from-amber-500 to-orange-500 text-white rounded-xl hover:from-amber-600 hover:to-orange-600 transition-all duration-300 text-sm font-semibold shadow-sm hover:shadow-md"
                    >
                        <Add fontSize="small" />
                        <span className="sm:hidden lg:inline">Nouveau lien</span>
                    </button>
                </div>
            </div>
        </div>
    );
};
